import { useNewEditTemplateCollectionContext } from "@pages/collectionAdministration/pages/NewEditTemplateCollection/context/NewEditTemplateCollectionContext"
import { useMemo, useState } from "react"

export const useRecurrencyOption = () => {

    const { chargeDetail, frecuencyRecurrencyOptions, buttonsOptions, } = useNewEditTemplateCollectionContext()
    const [isOpenModal, setIsOpenModal] = useState(false)

    const handleOpenCloseModal = ({ isOpenModal }) => {
        setIsOpenModal(isOpenModal)
    }

    const readRecurrenceOptions = useMemo(( ) => ({
        frequency_type: chargeDetail.recurrence.metadata?.charge_recurrence_frequency_id,
        issue_date: chargeDetail.recurrence.metadata?.issue_day,
        due_date: chargeDetail.recurrence.metadata?.due_day
      }), [chargeDetail.recurrence.metadata])

    return {
        isOpenModal,
        frecuencyRecurrencyOptions,
        buttonsOptions,
        chargeDetail,
        readRecurrenceOptions,
        handleOpenCloseModal
    }
}